import React, { useState } from "react";
import "./Navigation.css";
import { Col, Container, Nav, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { MenuItems } from "../MenuItem/MenuItem";
import { FaBars, FaTimes } from "react-icons/fa";

const Navigation = () => {
  const [menu, setMenu] = useState(false);
  console.log("initial:", menu);

  const handleMenuClick = () => {
    setMenu(!menu);
    console.log("clicked:", menu);
  };

  return (
    <>
      <Container fluid style={{ padding: "0", margin: "0" }}>
        <div className="NavbarItems">
          <h1 className="logo-title">Portfolio</h1>
          <div className="menu-icon" onClick={handleMenuClick}>
            {menu ? <FaTimes /> : <FaBars />}
          </div>
          <div>
            <ul className={menu ? "menu-items active" : "menu-items"}>
              {MenuItems.map((item) => (
                <li>
                  <Nav.Link as={HashLink} to={item.url} className={item.cName}>
                    {item.title}
                  </Nav.Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Navigation;
